import dateUtils from 'core/utils/date'
import { WEEK_SEPARATOR } from 'core/utils/weeks'
import type { IAPIAggregate, ICexAccount, ICexAccountsData, IMask, IQueryAPIData } from 'core/api/rest/queries'
import { TypedValue } from './computation-engine'
import { pad } from './number'
import type { Accounts } from '../models/accounts'
import i18next from 'i18next'

export const ACCOUNT_TRANSLATION_PREFIX = 'account.'

export enum DEPARTMENT_TYPE {
  COMMERCIAL = 'commercial',
  RECEPTION = 'reception and till',
  GENERAL_SERVICE = 'general services'
}

export enum INDICATORS {
  ADVISED_PRODUCTIVITY = 'ADVISED_PRODUCTIVITY',
  BUY_BACK_TO = 'BUY_BACK_TO',
  BUY_BACK_TO_PROGRESSION = 'BUY_BACK_TO_PROGRESSION',
  BUY_BACK_TO_N_1 = 'BUY_BACK_TO_N_1',
  CASH_HOURS = 'CASH_HOURS',
  COMMERCIAL_HOURS = 'COMMERCIAL_HOURS',
  DEPARTMENT_HOURS = 'DEPARTMENT_HOURS',
  ECOMMERCE_HOURS = 'ECOMMERCE_HOURS',
  ECOMMERCE_HOURS_STORE = 'ECOMMERCE_HOURS_STORE',
  INSTORE_COUNTRY_MARGIN_RATE = 'INSTORE_COUNTRY_MARGIN_RATE',
  INSTORE_COUNTRY_TURNOVER_PROGRESSION = 'INSTORE_COUNTRY_TURNOVER_PROGRESSION',
  INSTORE_MARGIN_CASH_REGISTER = 'INSTORE_MARGIN_CASH_REGISTER',
  INSTORE_MARGIN_RATE = 'INSTORE_MARGIN_RATE',
  INSTORE_MARGIN_RATE_N_1 = 'INSTORE_MARGIN_RATE_N_1',
  INSTORE_PART_OF_OMNI_MARGIN_CASH_REGISTER = 'INSTORE_PART_OF_OMNI_MARGIN_CASH_REGISTER',
  INSTORE_PART_OF_OMNI_MARGIN_CASH_REGISTER_N_1 = 'INSTORE_PART_OF_OMNI_MARGIN_CASH_REGISTER_N_1',
  INSTORE_PART_OF_OMNI_TURNOVER = 'INSTORE_PART_OF_OMNI_TURNOVER',
  INSTORE_PART_OF_OMNI_TURNOVER_N_1 = 'INSTORE_PART_OF_OMNI_TURNOVER_N_1',
  INSTORE_STORE_TURNOVER = 'INSTORE_STORE_TURNOVER',
  INSTORE_STORE_TURNOVER_PER_STORE_CASH_HOUR = 'INSTORE_STORE_TURNOVER_PER_STORE_CASH_HOURS',
  TARGET_STORE_PRODUCTIVITY = 'TARGET_STORE_PRODUCTIVITY',
  INSTORE_TURNOVER = 'INSTORE_TURNOVER',
  INSTORE_TURNOVER_PER_DEPARTMENT_HOUR = 'INSTORE_TURNOVER_PER_DEPARTMENT_HOUR',
  INSTORE_TURNOVER_PER_HOUR = 'INSTORE_TURNOVER_PER_HOUR',
  INSTORE_TURNOVER_PROGRESSION = 'INSTORE_TURNOVER_PROGRESSION',
  LINEAR_METERS = 'LINEAR_METERS',
  NON_COMMERCIAL_HOURS = 'NON_COMMERCIAL_HOURS',
  OMNICHANNEL_COUNTRY_MARGIN_RATE = 'OMNICHANNEL_COUNTRY_MARGIN_RATE',
  OMNICHANNEL_COUNTRY_TURNOVER_PROGRESSION = 'OMNICHANNEL_COUNTRY_TURNOVER_PROGRESSION',
  OMNICHANNEL_MARGIN_RATE = 'OMNICHANNEL_MARGIN_RATE',
  OMNICHANNEL_QUANTITY_PROGRESSION = 'OMNICHANNEL_QUANTITY_PROGRESSION',
  OMNICHANNEL_TURNOVER = 'OMNICHANNEL_TURNOVER',
  OMNICHANNEL_TURNOVER_PER_HOUR = 'OMNICHANNEL_TURNOVER_PER_HOUR',
  OMNICHANNEL_TURNOVER_PROGRESSION = 'OMNICHANNEL_TURNOVER_PROGRESSION',
  OUTSTORE_COUNTRY_MARGIN_RATE = 'OUTSTORE_COUNTRY_MARGIN_RATE',
  OUTSTORE_COUNTRY_TURNOVER_PROGRESSION = 'OUTSTORE_COUNTRY_TURNOVER_PROGRESSION',
  OUTSTORE_MARGIN_CASH_REGISTER = 'OUTSTORE_MARGIN_CASH_REGISTER',
  OUTSTORE_MARGIN_RATE = 'OUTSTORE_MARGIN_RATE',
  OUTSTORE_MARGIN_RATE_PROGRESSION = 'OUTSTORE_MARGIN_RATE_PROGRESSION',
  OUTSTORE_MARGIN_RATE_N_1 = 'OUTSTORE_MARGIN_RATE_N_1',
  OUTSTORE_PART_OF_OMNI_MARGIN_CASH_REGISTER = 'OUTSTORE_PART_OF_OMNI_MARGIN_CASH_REGISTER',
  OUTSTORE_PART_OF_OMNI_MARGIN_CASH_REGISTER_N_1 = 'OUTSTORE_PART_OF_OMNI_MARGIN_CASH_REGISTER_N_1',
  OUTSTORE_PART_OF_OMNI_TURNOVER = 'OUTSTORE_PART_OF_OMNI_TURNOVER',
  OUTSTORE_PART_OF_OMNI_TURNOVER_N_1 = 'OUTSTORE_PART_OF_OMNI_TURNOVER_N_1',
  OUTSTORE_TURNOVER = 'OUTSTORE_TURNOVER',
  OUTSTORE_TURNOVER_PROGRESSION = 'OUTSTORE_TURNOVER_PROGRESSION',
  SQUARE_METERS = 'SQUARE_METERS',
  STORE_CASH_HOURS = 'STORE_CASH_HOURS',
  TARGET_PRODUCTIVITY = 'TARGET_PRODUCTIVITY',
  THEORETICAL_HOURS = 'THEORETICAL_HOURS',
  TOTAL_HOURS_INSTORE = 'TOTAL_HOURS_INSTORE',
  TOTAL_HOURS_OMNI = 'TOTAL_HOURS_OMNI',
  TURNOVER = 'OMNICHANNEL_TURNOVER',
  CC_FROM_STORE_BIKE_ORDER_NUMBER_STORE = 'CC_FROM_STORE_BIKE_ORDER_NUMBER_STORE',
  CC_FROM_STORE_STANDARD_ORDER_NUMBER_STORE = 'CC_FROM_STORE_STANDARD_ORDER_NUMBER_STORE',
  CC_FROM_LOG_BIKE_ORDER_NUMBER_STORE = 'CC_FROM_LOG_BIKE_ORDER_NUMBER_STORE',
  CC_FROM_LOG_STANDARD_ORDER_NUMBER_STORE = 'CC_FROM_LOG_STANDARD_ORDER_NUMBER_STORE',
  ADVISED_CC_FROM_STORE_BIKE_ORDER_NUMBER_STORE = 'ADVISED_CC_FROM_STORE_BIKE_ORDER_NUMBER_STORE',
  ADVISED_CC_FROM_STORE_STANDARD_ORDER_NUMBER_STORE = 'ADVISED_CC_FROM_STORE_STANDARD_ORDER_NUMBER_STORE',
  ADVISED_CC_FROM_LOG_BIKE_ORDER_NUMBER_STORE = 'ADVISED_CC_FROM_LOG_BIKE_ORDER_NUMBER_STORE',
  ADVISED_CC_FROM_LOG_STANDARD_ORDER_NUMBER_STORE = 'ADVISED_CC_FROM_LOG_STANDARD_ORDER_NUMBER_STORE',
  DIGITAL_STORES_PART_OF_INSTORE_TURNOVER = 'DIGITAL_STORES_PART_OF_INSTORE_TURNOVER',
  PHYSICAL_STORES_PART_OF_INSTORE_TURNOVER = 'PHYSICAL_STORES_PART_OF_INSTORE_TURNOVER',
  DIGITAL_STORES_PART_OF_INSTORE_TURNOVER_N_1 = 'DIGITAL_STORES_PART_OF_INSTORE_TURNOVER_N_1',
  PHYSICAL_STORES_PART_OF_INSTORE_TURNOVER_N_1 = 'PHYSICAL_STORES_PART_OF_INSTORE_TURNOVER_N_1',
  PHYSICAL_STORES_TURNOVER = 'PHYSICAL_STORES_TURNOVER',
  PHYSICAL_STORES_TURNOVER_N_1 = 'PHYSICAL_STORES_TURNOVER_N_1',
  DIGITAL_STORES_TURNOVER = 'DIGITAL_STORES_TURNOVER',
  DIGITAL_STORES_TURNOVER_N_1 = 'DIGITAL_STORES_TURNOVER_N_1',
  INSTORE_AVERAGE_RETAIL_BASKET = 'INSTORE_AVERAGE_RETAIL_BASKET',
  INSTORE_COUNTRY_AVERAGE_RETAIL_BASKET = 'INSTORE_COUNTRY_AVERAGE_RETAIL_BASKET',
  INSTORE_AVERAGE_RETAIL_BASKET_PROGRESSION = 'INSTORE_AVERAGE_RETAIL_BASKET_PROGRESSION',
  INSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESSION = 'INSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESSION',
  OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET = 'OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET',
  OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESS = 'OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESS',
  OUTSTORE_COUNTRY_AVERAGE_RETAIL_BASKET = 'OUTSTORE_COUNTRY_AVERAGE_RETAIL_BASKET',
  OUTSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESSION = 'OUTSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESSION',

  INSTORE_AVERAGE_RETAIL_BASKET_N_1 = 'INSTORE_AVERAGE_RETAIL_BASKET_N_1',
  INSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_N_1 = 'INSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_N_1',
  INSTORE_AVERAGE_RETAIL_BASKET_N_2 = 'INSTORE_AVERAGE_RETAIL_BASKET_N_2',
  INSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_N_2 = 'INSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_N_2',
  INSTORE_AVERAGE_RETAIL_BASKET_PROGRESSION_N_1 = 'INSTORE_AVERAGE_RETAIL_BASKET_PROGRESSION_N_1',
  INSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESSION_N_1 = 'INSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESSION_N_1',
  OMNICHANNEL_AVERAGE_RETAIL_BASKET_N_1 = 'OMNICHANNEL_AVERAGE_RETAIL_BASKET_N_1',
  OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET_N_1 = 'OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET_N_1',
  OMNICHANNEL_AVERAGE_RETAIL_BASKET_N_2 = 'OMNICHANNEL_AVERAGE_RETAIL_BASKET_N_2',
  OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET_N_2 = 'OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET_N_2',
  OMNICHANNEL_AVERAGE_RETAIL_BASKET_PROGRESSION_N_1 = 'OMNICHANNEL_AVERAGE_RETAIL_BASKET_PROGRESSION_N_1',
  OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESS_N_2 = 'OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESS_N_2',
  OUTSTORE_AVERAGE_RETAIL_BASKET_N_1 = 'OUTSTORE_AVERAGE_RETAIL_BASKET_N_1',
  OUTSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_N_1 = 'OUTSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_N_1',
  OUTSTORE_AVERAGE_RETAIL_BASKET_N_2 = 'OUTSTORE_AVERAGE_RETAIL_BASKET_N_2',
  OUTSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_N_2 = 'OUTSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_N_2',
  OUTSTORE_AVERAGE_RETAIL_BASKET_PROGRESSION_N_1 = 'OUTSTORE_AVERAGE_RETAIL_BASKET_PROGRESSION_N_1',
  OUTSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESSION_N_1 = 'OUTSTORE_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESSION_N_1',

  INSTORE_AVERAGE_SELLING_PRICE = 'INSTORE_AVERAGE_SELLING_PRICE',
  INSTORE_COUNTRY_AVERAGE_SELLING_PRICE = 'INSTORE_COUNTRY_AVERAGE_SELLING_PRICE',
  INSTORE_AVERAGE_SELLING_PRICE_PROGRESSION = 'INSTORE_AVERAGE_SELLING_PRICE_PROGRESSION',
  INSTORE_COUNTRY_AVERAGE_SELLING_PRICE_PROGRESSION = 'INSTORE_COUNTRY_AVERAGE_SELLING_PRICE_PROGRESSION',
  INSTORE_AVERAGE_SELLING_PRICE_N_1 = 'INSTORE_AVERAGE_SELLING_PRICE_N_1',
  INSTORE_COUNTRY_AVERAGE_SELLING_PRICE_N_1 = 'INSTORE_COUNTRY_AVERAGE_SELLING_PRICE_N_1',
  INSTORE_AVERAGE_SELLING_PRICE_N_2 = 'INSTORE_AVERAGE_SELLING_PRICE_N_2',
  INSTORE_COUNTRY_AVERAGE_SELLING_PRICE_N_2 = 'INSTORE_COUNTRY_AVERAGE_SELLING_PRICE_N_2',
  INSTORE_AVERAGE_SELLING_PRICE_PROGRESSION_N_1 = 'INSTORE_AVERAGE_SELLING_PRICE_PROGRESSION_N_1',
  INSTORE_COUNTRY_AVERAGE_SELLING_PRICE_PROGRESSION_N_1 = 'INSTORE_COUNTRY_AVERAGE_SELLING_PRICE_PROGRESSION_N_1',
  OMNICHANNEL_AVERAGE_SELLING_PRICE = 'OMNICHANNEL_AVERAGE_SELLING_PRICE',
  OMNICHANNEL_COUNTRY_AVERAGE_SELLING_PRICE = 'OMNICHANNEL_COUNTRY_AVERAGE_SELLING_PRICE',
  OMNICHANNEL_AVERAGE_SELLING_PRICE_N_1 = 'OMNICHANNEL_AVERAGE_SELLING_PRICE_N_1',
  OMNICHANNEL_COUNTRY_AVERAGE_SELLING_PRICE_N_1 = 'OMNICHANNEL_COUNTRY_AVERAGE_SELLING_PRICE_N_1',
  OMNICHANNEL_AVERAGE_SELLING_PRICE_N_2 = 'OMNICHANNEL_AVERAGE_SELLING_PRICE_N_2',
  OMNICHANNEL_COUNTRY_AVERAGE_SELLING_PRICE_N_2 = 'OMNICHANNEL_COUNTRY_AVERAGE_SELLING_PRICE_N_2',
  OMNICHANNEL_AVERAGE_SELLING_PRICE_PROGRESSION = 'OMNICHANNEL_AVERAGE_SELLING_PRICE_PROGRESSION',
  OMNICHANNEL_COUNTRY_AVERAGE_SELLING_PRICE_PROGRESS = 'OMNICHANNEL_COUNTRY_AVERAGE_SELLING_PRICE_PROGRESS',

  INSTORE_QUANTITY_PER_CUSTOMER = 'INSTORE_QUANTITY_PER_CUSTOMER',
  INSTORE_COUNTRY_QUANTITY_PER_CUSTOMER = 'INSTORE_COUNTRY_QUANTITY_PER_CUSTOMER',
  INSTORE_QUANTITY_PER_CUSTOMER_N_1 = 'INSTORE_QUANTITY_PER_CUSTOMER_N_1',
  INSTORE_COUNTRY_QUANTITY_PER_CUSTOMER_N_1 = 'INSTORE_COUNTRY_QUANTITY_PER_CUSTOMER_N_1',
  INSTORE_QUANTITY_PER_CUSTOMER_N_2 = 'INSTORE_QUANTITY_PER_CUSTOMER_N_2',
  INSTORE_COUNTRY_QUANTITY_PER_CUSTOMER_N_2 = 'INSTORE_COUNTRY_QUANTITY_PER_CUSTOMER_N_2',
  INSTORE_QUANTITY_PER_CUSTOMER_PROGRESSION = 'INSTORE_QUANTITY_PER_CUSTOMER_PROGRESSION',
  INSTORE_COUNTRY_QUANTITY_PER_CUSTOMER_PROGRESSION = 'INSTORE_COUNTRY_QUANTITY_PER_CUSTOMER_PROGRESSION',
  INSTORE_QUANTITY_PER_CUSTOMER_PROGRESSION_N_1 = 'INSTORE_QUANTITY_PER_CUSTOMER_PROGRESSION_N_1',
  INSTORE_COUNTRY_QUANTITY_PER_CUSTOMER_PROGRESSION_N_1 = 'INSTORE_COUNTRY_QUANTITY_PER_CUSTOMER_PROGRESSION_N_1',
  INSTORE_QUANTITY_PROGRESSION = 'INSTORE_QUANTITY_PROGRESSION',
  INSTORE_COUNTRY_QUANTITY_PROGRESSION = 'INSTORE_COUNTRY_QUANTITY_PROGRESSION',
  INSTORE_QUANTITY_PROGRESSION_N_1 = 'INSTORE_QUANTITY_PROGRESSION_N_1',
  INSTORE_COUNTRY_QUANTITY_PROGRESSION_N_1 = 'INSTORE_COUNTRY_QUANTITY_PROGRESSION_N_1',

  OMNICHANNEL_COUNTRY_QUANTITY_PER_CUSTOMER = 'OMNICHANNEL_COUNTRY_QUANTITY_PER_CUSTOMER',
  OMNICHANNEL_QUANTITY_PER_CUSTOMER_N_1 = 'OMNICHANNEL_QUANTITY_PER_CUSTOMER_N_1',
  OMNICHANNEL_COUNTRY_QUANTITY_PER_CUSTOMER_N_1 = 'OMNICHANNEL_COUNTRY_QUANTITY_PER_CUSTOMER_N_1',
  OMNICHANNEL_QUANTITY_PER_CUSTOMER_N_2 = 'OMNICHANNEL_QUANTITY_PER_CUSTOMER_N_2',
  OMNICHANNEL_COUNTRY_QUANTITY_PER_CUSTOMER_N_2 = 'OMNICHANNEL_COUNTRY_QUANTITY_PER_CUSTOMER_N_2',
  OMNICHANNEL_COUNTRY_QUANTITY_PER_CUSTOMER_PROGRESS = 'OMNICHANNEL_COUNTRY_QUANTITY_PER_CUSTOMER_PROGRESS',
  OMNICHANNEL_QUANTITY_PER_CUSTOMER_PROGRESSION_N_1 = 'OMNICHANNEL_QUANTITY_PER_CUSTOMER_PROGRESSION_N_1',
  OMNICHANNEL_COUNTRY_QUANTITY_PER_CUSTOMER_PROGRESS_N_1 = 'OMNICHANNEL_COUNTRY_QUANTITY_PER_CUSTOMER_PROGRESS_N_1',
  OMNICHANNEL_COUNTRY_QUANTITY_PROGRESSION = 'OMNICHANNEL_COUNTRY_QUANTITY_PROGRESSION',
  OMNICHANNEL_QUANTITY_PROGRESSION_N_1 = 'OMNICHANNEL_QUANTITY_PROGRESSION_N_1',
  OMNICHANNEL_COUNTRY_QUANTITY_PROGRESSION_N_1 = 'OMNICHANNEL_COUNTRY_QUANTITY_PROGRESSION_N_1',

  INSTORE_TICKET_PROGRESSION = 'INSTORE_TICKET_PROGRESSION',
  INSTORE_COUNTRY_TICKET_PROGRESSION = 'INSTORE_COUNTRY_TICKET_PROGRESSION',
  INSTORE_TICKET_PROGRESSION_N_1 = 'INSTORE_TICKET_PROGRESSION_N_1',
  INSTORE_COUNTRY_TICKET_PROGRESSION_N_1 = 'INSTORE_COUNTRY_TICKET_PROGRESSION_N_1',
  OMNICHANNEL_COUNTRY_TICKET_PROGRESSION = 'OMNICHANNEL_COUNTRY_TICKET_PROGRESSION',
  OMNICHANNEL_TICKET_PROGRESSION_N_1 = 'OMNICHANNEL_TICKET_PROGRESSION_N_1',
  OMNICHANNEL_COUNTRY_TICKET_PROGRESSION_N_1 = 'OMNICHANNEL_COUNTRY_TICKET_PROGRESSION_N_1',
  OUTSTORE_COUNTRY_TICKET_PROGRESSION = 'OUTSTORE_COUNTRY_TICKET_PROGRESSION',
  OUTSTORE_TICKET_PROGRESSION_N_1 = 'OUTSTORE_TICKET_PROGRESSION_N_1',
  OUTSTORE_COUNTRY_TICKET_PROGRESSION_N_1 = 'OUTSTORE_COUNTRY_TICKET_PROGRESSION_N_1',

  DECATHLON_PRO_INSTORE_PART_OF_INSTORE_TURNOVER = 'DECATHLON_PRO_INSTORE_PART_OF_INSTORE_TURNOVER',
  DECATHLON_PRO_INSTORE_PART_OF_INSTORE_TURNOVER_N_1 = 'DECATHLON_PRO_INSTORE_PART_OF_INSTORE_TURNOVER_N_1',
  DECATHLON_PRO_INSTORE_TURNOVER = 'DECATHLON_PRO_INSTORE_TURNOVER',
  DECATHLON_PRO_INSTORE_TURNOVER_N_1 = 'DECATHLON_PRO_INSTORE_TURNOVER_N_1',
  //HOURS_ENVELOPE is a front indicator only, it used in hours piloting screen.
  HOURS_ENVELOPE = 'HOURS_ENVELOPE',

  // Home Page Indicators
  INSTORE_TICKET = 'INSTORE_TICKET',
  OUTSTORE_AVERAGE_SELLING_PRICE = 'OUTSTORE_AVERAGE_SELLING_PRICE',
  OUTSTORE_AVERAGE_SELLING_PRICE_PROGRESSION = 'OUTSTORE_AVERAGE_SELLING_PRICE_PROGRESSION',
  INSTORE_COUNTRY_TICKET = 'INSTORE_COUNTRY_TICKET',
  OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESSION = 'OMNICHANNEL_COUNTRY_AVERAGE_RETAIL_BASKET_PROGRESSION',
  OMNICHANNEL_COUNTRY_TICKET = 'OMNICHANNEL_COUNTRY_TICKET',
  OMNICHANNEL_COUNTRY_AVERAGE_SELLING_PRICE_PROGRESSION = 'OMNICHANNEL_COUNTRY_AVERAGE_SELLING_PRICE_PROGRESSION',
  OUTSTORE_COUNTRY_TICKET = 'OUTSTORE_COUNTRY_TICKET',
  INSTORE_TURNOVER_N_1 = 'INSTORE_TURNOVER_N_1',
  INSTORE_MARGIN_CASH_REGISTER_N_1 = 'INSTORE_MARGIN_CASH_REGISTER_N_1',
  INSTORE_MARGIN_CASH_REGISTER_PROGRESSION = 'INSTORE_MARGIN_CASH_REGISTER_PROGRESSION',
  OUTSTORE_TURNOVER_N_1 = 'OUTSTORE_TURNOVER_N_1',
  OMNICHANNEL_TURNOVER_N_1 = 'OMNICHANNEL_TURNOVER_N_1',
  OMNICHANNEL_MARGIN_CASH_REGISTER = 'OMNICHANNEL_MARGIN_CASH_REGISTER',
  OUTSTORE_MARGIN_CASH_REGISTER_N_1 = 'OUTSTORE_MARGIN_CASH_REGISTER_N_1',
  OMNICHANNEL_MARGIN_CASH_REGISTER_N_1 = 'OMNICHANNEL_MARGIN_CASH_REGISTER_N_1',
  OUTSTORE_MARGIN_CASH_REGISTER_PROGRESSION = 'OUTSTORE_MARGIN_CASH_REGISTER_PROGRESSION',
  OMNICHANNEL_MARGIN_CASH_REGISTER_PROGRESSION = 'OMNICHANNEL_MARGIN_CASH_REGISTER_PROGRESSION',
  INSTORE_QUANTITY_PER_HOUR = 'INSTORE_QUANTITY_PER_HOUR',
  INSTORE_QUANTITY = 'INSTORE_QUANTITY',
  INSTORE_QUANTITY_N_1 = 'INSTORE_QUANTITY_N_1',
  INSTORE_STORE_TRANSACTION_PER_STORE_CASH_HOURS = 'INSTORE_STORE_TRANSACTION_PER_STORE_CASH_HOURS',
  WORKSHOP_TO = 'WORKSHOP_TO',
  WORKSHOP_TO_PROGRESSION = 'WORKSHOP_TO_PROGRESSION',
  WORKSHOP_TO_N_1 = 'WORKSHOP_TO_N_1',
  RETURN_DECOTE_TO = 'RETURN_DECOTE_TO',
  RETURN_DECOTE_TO_N_1 = 'RETURN_DECOTE_TO_N_1',
  RETURN_DECOTE_TO_PROGRESSION = 'RETURN_DECOTE_TO_PROGRESSION',
  RENTAL_TO = 'RENTAL_TO',
  RENTAL_TO_PROGRESSION = 'RENTAL_TO_PROGRESSION',
  RENTAL_TO_N_1 = 'RENTAL_TO_N_1',
  SUSTAINABLE_TO = 'SUSTAINABLE_TO',
  SUSTAINABLE_TO_N_1 = 'SUSTAINABLE_TO_N_1',
  SUSTAINABLE_TO_PROGRESSION = 'SUSTAINABLE_TO_PROGRESSION',

  ADVISED_INSTORE_TURNOVER = 'ADVISED_INSTORE_TURNOVER',
  DIRECTOR_PROBABLE_STORE_INSTORE_GMV = 'DIRECTOR_PROBABLE_STORE_INSTORE_GMV',
  DIRECTOR_PROBABLE_STORE_INSTORE_GMV_PROGRESSION = 'DIRECTOR_PROBABLE_STORE_INSTORE_GMV_PROGRESSION',
  DIRECTOR_PROBABLE_STORE_OUTSTORE_GMV = 'DIRECTOR_PROBABLE_STORE_OUTSTORE_GMV',
  DIRECTOR_PROBABLE_STORE_OUTSTORE_GMV_PROGRESSION = 'DIRECTOR_PROBABLE_STORE_OUTSTORE_GMV_PROGRESSION',
  DIRECTOR_PROBABLE_STORE_PHYSICAL_GMV = 'DIRECTOR_PROBABLE_STORE_PHYSICAL_GMV',
  DIRECTOR_PROBABLE_STORE_DIGITAL_GMV = 'DIRECTOR_PROBABLE_STORE_DIGITAL_GMV',
  DIRECTOR_PROBABLE_STORE_DECATHLON_PRO_GMV = 'DIRECTOR_PROBABLE_STORE_DECATHLON_PRO_GMV',
  DIRECTOR_STORE_ADVISED_INSTORE_GMV_PROGRESSION = 'DIRECTOR_STORE_ADVISED_INSTORE_GMV_PROGRESSION',
  DIRECTOR_STORE_INSTORE_GMV = 'DIRECTOR_STORE_INSTORE_GMV',
  DIRECTOR_STORE_OUTSTORE_GMV = 'DIRECTOR_STORE_OUTSTORE_GMV',
  DIRECTOR_STORE_PHYSICAL_GMV = 'DIRECTOR_STORE_PHYSICAL_GMV',
  DIRECTOR_STORE_DIGITAL_GMV = 'DIRECTOR_STORE_DIGITAL_GMV',
  DIRECTOR_STORE_DECATHLON_PRO_GMV = 'DIRECTOR_STORE_DECATHLON_PRO_GMV'
}

const CONSOLIDATED_LABEL_SEPARATOR = '@'

export type IAccounts = Record<string, IAccount>

export interface IAccount {
  index: number
  aggregate_formula: string
  formulas: string[]
  label: string
  label_code: string
  mask: IMask
  is_persisted: boolean
  is_temporal_average: boolean
  is_editable: boolean
  weight: number
  is_visible?: boolean
  is_hidden: boolean
  is_child?: boolean
  cells: ICells
  lockedCells: string[]
  children: string[]
  are_children_fixed?: boolean
}

export type ICells = Record<string, ICell>

export interface ICell {
  value: number
  /**
   * used to differentiate the case when input is set to value "0"
   * and the case when input isn't Set yet and the value is "null"
   * If input is cleared, value is set to initial_value
   */
  initial_value: number
  is_editable: boolean
  type: TypedValue
  mask?: IMask
  isEdited?: boolean
  hasAnnexeDetails?: boolean
  isComputed?: boolean
  is_persisted?: boolean
  is_hidden?: boolean
}

export interface ITemplateAccount {
  account: string
  index: number
  is_collapsed?: boolean
  is_hidden?: boolean
  children?: ITemplateAccountChildren[]
  are_children_fixed?: boolean
  isHiddenForComputation?: boolean
}

export interface ITemplateAccountChildren {
  account: string
  index: number
}

export type IFormattedAPIData<D> = Record<string, D & { index: number }>

export type IFormattedAPIQueryData<D = ICexAccount | IAPIAggregate, E = {}> = IQueryAPIData<IFormattedAPIData<D>, E>

export interface IAccountsGetterOptions {
  disableEditableCells?: boolean
}

export const joinLabels = (labels: string[], separator: string = CONSOLIDATED_LABEL_SEPARATOR): string => {
  return labels.join(separator)
}

export const splitLabel = (label: string, separator: string = CONSOLIDATED_LABEL_SEPARATOR): string[] => {
  return label.split(separator)
}

export const getAllWeeksByYearWeeks = (
  year: number,
  yearWeeksNumber: number = dateUtils.getTotalYearWeeksNumber(year)
): string[] => {
  const allWeeks = []
  for (let i = 1; i <= yearWeeksNumber; i++) {
    allWeeks.push(joinLabels([year.toString(), pad(i)], WEEK_SEPARATOR))
  }
  return allWeeks
}

export const formatData = <D extends { label_code: string } = ICexAccount, E = object>(
  dataToFormat: IQueryAPIData<D[], E>
): IFormattedAPIQueryData<D, E> => {
  const { data, aggregates = [], ...others } = dataToFormat?.data || { data: [] }
  const newData = [...data, ...aggregates]

  const accountFormatted = newData.reduce<IFormattedAPIData<D | IAPIAggregate>>((accounts, account, index) => {
    const newAccount = { ...account, index }
    accounts = { ...accounts, [account.label_code]: newAccount }
    return accounts
  }, {})

  return {
    // @ts-expect-error The expected type comes from property 'data' which is declared here on type 'IFormattedAPIQueryData<D, E>'
    data: {
      data: accountFormatted,
      aggregates,
      ...others
    }
  }
}

export const getCells = (
  dataAggregates: ICells,
  dataAccounts: ICexAccountsData,
  options?: IAccountsGetterOptions
): [ICells, string[], boolean] => {
  let hasEditableCells = false
  const lockedCells = []
  const aggregates = Object.keys(dataAggregates).reduce<ICells>((cells, cellId) => {
    const aggregate = dataAggregates[cellId]
    const isEditableCell = options && options.disableEditableCells ? false : aggregate.is_editable
    hasEditableCells = isEditableCell || hasEditableCells
    return {
      ...cells,
      [cellId]: {
        value: aggregate.value,
        initial_value: aggregate.initial_value,
        isComputed: aggregate.isComputed,
        is_editable: isEditableCell,
        type: TypedValue.Pilotable,
        is_persisted: aggregate.is_persisted || false
      }
    }
  }, {})

  const accounts = Object.keys(dataAccounts).reduce<ICells>((cells, cellId) => {
    const cell = dataAccounts[cellId]
    const { is_editable, has_annexe_details: hasAnnexeDetails, type, is_persisted } = cell
    const isEditableCell = options && options.disableEditableCells ? false : is_editable
    hasEditableCells = isEditableCell || hasEditableCells
    if (type === TypedValue.PilotedManually) {
      lockedCells.push(cellId)
    }
    // Fix to replace cell.value (=-0) by 0
    const value = cell.value === 0 ? 0 : cell.value
    return {
      ...cells,
      [cellId]: {
        value,
        initial_value: value,
        type,
        is_editable: isEditableCell,
        hasAnnexeDetails,
        is_persisted: is_persisted || false
      }
    }
  }, {})

  return [{ ...aggregates, ...accounts }, lockedCells, hasEditableCells]
}

export const getAccount = (
  dataFromCex: IFormattedAPIQueryData,
  accounts: Accounts,
  { children, account, index, are_children_fixed, isHiddenForComputation }: ITemplateAccount,
  dataAggregates: ICells = {},
  options?: IAccountsGetterOptions,
  accountLabelFromConsolidatedLabel?: string,
  displayLabel?: string
): IAccount | null => {
  const accountObj = accounts[accountLabelFromConsolidatedLabel || account]
  const accountData = dataFromCex.data.data[account] as ICexAccount

  if (accountData && accountObj) {
    const { aggregate_formula, formulas, label, label_code, mask, weight, is_persisted, is_temporal_average } =
      accountObj
    const { data, is_hidden }: ICexAccount = accountData
    const [cells, lockedCells, hasEditableCells] = getCells(dataAggregates, data, options)

    return {
      index,
      aggregate_formula,
      formulas,
      label: displayLabel || label,
      label_code,
      mask,
      is_persisted,
      is_temporal_average,
      weight,
      cells,
      is_editable: hasEditableCells,
      lockedCells,
      is_hidden: is_hidden || isHiddenForComputation || false,
      children: children ? children.map(child => child.account) : null,
      is_child: false,
      are_children_fixed
    }
  }
  return null
}

export const getChild = (
  accounts: Accounts,
  childLabel: string,
  dataFromCex: IFormattedAPIQueryData,
  dataAggregates: ICells = {},
  options?: IAccountsGetterOptions,
  childLabelFromConsolidatedLabel?: string,
  displayLabel?: string
): IAccount | null => {
  const { aggregate_formula, formulas, label, label_code, mask, weight, is_persisted, is_temporal_average } =
    accounts[childLabelFromConsolidatedLabel || childLabel]
  const child = dataFromCex.data.data[childLabel]
  if (child) {
    const { data, index, is_hidden }: ICexAccount = dataFromCex.data.data[childLabel] as ICexAccount
    const [cells, lockedCells, hasEditableCells] = getCells(dataAggregates, data, options)
    return {
      index,
      aggregate_formula,
      formulas,
      label: displayLabel || label,
      label_code,
      mask,
      is_persisted,
      is_temporal_average,
      weight,
      children: [], // Currently, children accounts can't be parents
      cells,
      is_editable: hasEditableCells,
      lockedCells,
      is_hidden,
      is_child: true
    }
  }
  return null
}

/**
 * Get an account by label code
 * @param accountLabel
 * @param accounts
 * @return account
 * @example getAccountByLabelCode("TOTO", {TOTO: {...}, ...}) => {...}
 */
export const getAccountByLabelCode = (accountLabel: string, accounts: IAccounts): IAccount | null =>
  accounts[accountLabel] ? { ...accounts[accountLabel] } : null

export const getAccountTranslation = (accountLabelCode: string) =>
  i18next.t(ACCOUNT_TRANSLATION_PREFIX + accountLabelCode)
